import { useEffect, useState } from "react";
import requests from "API/propertiesRequests";

const GetSuburbs = () => {
  const [suburb, setSuburb] = useState([]);

  useEffect(() => {
    fetch(requests.getSuburbs()).then(async (response) => {
      if (response.ok) {
        setSuburb(await response.json());
      }
    });
  }, []);
  return [suburb];
};

export default GetSuburbs;
